module.exports = __webpack_public_path__ + "static/media/Plant-photo.81a6a285.png";